import { useAuthorizationServiceV1 } from "@rw1/api-services";
import { Authorization_V1 } from "@rw1/auto-generated-clients";
import { useQuery } from "@tanstack/react-query";
import { useMemo } from "react";
import { STALE_TIME_MS } from "./constants";
import { QueryKeys } from "./QueryKeys";

interface UseCurrentUserRolesResult {
    userRoles: Authorization_V1.UserRole[] | undefined;
    isLoading: boolean;
    error: Error | null;
}

export const useCurrentUserRoles = (): UseCurrentUserRolesResult => {
    const authorizationServiceV1 = useAuthorizationServiceV1();

    const {
        data: userRoles,
        isLoading,
        error,
    } = useQuery<Authorization_V1.UserRole[]>({
        queryKey: [QueryKeys.CurrentUserRoles],
        queryFn: () => {


            return authorizationServiceV1.getCurrentUserRoles();
        },
        enabled: true,
        staleTime: STALE_TIME_MS,
        retry: false,
    });

    return useMemo(() => {
        return {
            userRoles,
            isLoading: isLoading || (userRoles === undefined && !error),
            error: error ?? null,
        };
    }, [userRoles, isLoading, error]);
};